import upperFirst from 'lodash/upperFirst';
export var DeprecateType;
(function (DeprecateType) {
    DeprecateType["component"] = "\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442";
    DeprecateType["event"] = "\u0441\u043E\u0431\u044B\u0442\u0438\u0435";
    DeprecateType["prop"] = "\u043F\u0440\u043E\u043F";
    DeprecateType["slot"] = "\u0441\u043B\u043E\u0442";
})(DeprecateType || (DeprecateType = {}));
function createMessage(message, component) {
    if (component) {
        component.__loggedMessages = component.__loggedMessages || [];
        if (component.__loggedMessages.includes(message))
            return;
        component.__loggedMessages.push(message);
    }
    const componentName = component === null || component === void 0 ? void 0 : component.name;
    const messagePrefix = componentName ? `[${componentName}] ` : '';
    return `${messagePrefix}${message}`;
}
export function consoleInfo(message, component) {
    const newMessage = createMessage(message, component);
    newMessage && console.info(newMessage);
}
export function consoleWarn(message, component) {
    const newMessage = createMessage(message, component);
    newMessage && console.warn(newMessage);
}
export function consoleError(message, component) {
    const newMessage = createMessage(message, component);
    newMessage && console.error(newMessage);
}
export function deprecate(original, todo, type, component) {
    todo = upperFirst(todo);
    todo = todo[todo.length - 1] === '.' ? todo : `${todo}.`;
    const markedWord = type === DeprecateType.event ? 'помечено' : 'помечен';
    consoleWarn(`${type ? `${type} ` : ''}${original} ${markedWord} устаревшим. ${todo}`, component);
}
export function deprecateProp(original, todo, component) {
    return deprecate(original, todo, DeprecateType.prop, component);
}
export function deprecateEvent(original, todo, component) {
    return deprecate(original, todo, DeprecateType.event, component);
}
export function deprecateComponent(original, todo, component) {
    return deprecate(original, todo, DeprecateType.component, component);
}
export function deprecateSlot(original, todo, component) {
    return deprecate(original, todo, DeprecateType.slot, component);
}

//# sourceMappingURL=console.js.map
